// extracted by mini-css-extract-plugin
export default {"comment":"ReportIcon_comment__l41B8","exclamationPoint":"ReportIcon_exclamationPoint__oGBmr"};